// extracted by mini-css-extract-plugin
export default {"menu":"bh_kp"};